export default __webpack_public_path__ + "static/media/Admitidos_Gestão_Ambiental2023_24.1c95bcbe.pdf";